import React from 'react';

// Mensagem de incentivo por dia da semana (0=domingo … 6=sábado).
const WEEKDAY_MESSAGES = [
  'Domingo é dia de recarregar — que tal um aquecimento pro SAEB? 🌤️',
  'Bora começar a semana com tudo rumo ao SAEB! 💪',
  'Terça de foco: mais um passo rumo ao SAEB? 🚀',
  'Já é quarta! Mantém o ritmo na trilha SAEB. 🔥',
  'Quinta voando! Avança mais um bloco da trilha. ⚡',
  'Sextou! Que tal fechar a semana evoluindo no SAEB? 🎉',
  'Sábado também conta — um pouquinho de SAEB hoje? 😎'
];

// Saudação completa da T.I.A: nome + incentivo do dia.
export function greetingForDay(day, firstName) {
  const hi = firstName ? `Oi, ${firstName}! 👋` : 'Oi! 👋';
  return `${hi} ${WEEKDAY_MESSAGES[day] ?? WEEKDAY_MESSAGES[1]}`;
}

// Trilha pontilhada decorativa (SVG inline, aria-hidden).
export function DottedTrail() {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      className="pointer-events-none absolute right-0 top-0 h-full w-28 opacity-60"
      viewBox="0 0 112 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="none"
    >
      <path
        d="M 8 70 Q 40 50 60 30 Q 78 12 100 8"
        stroke="var(--color-secondary-light)"
        strokeWidth="2"
        strokeDasharray="5 5"
        strokeLinecap="round"
        fill="none"
      />
    </svg>
  );
}
